import styles from "./App.module.scss";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import {
  BlogLogo,
  GitHubIcon,
  LinkedInIcon,
  ProductHuntIcon,
  YoutubeIcon,
} from "./Icons";

function App() {
  return (
    <div className={styles.container}>
      <div className={styles.page}>
        <div className={styles.imageLine}>
          <img
            src="/ozgur-adem-isikli.png"
            alt="Ozgur Isikli"
            height={160}
            width={160}
            className={styles.image}
          />
        </div>
        <header className={styles.header}>
          <h1 className={styles.title}>
            I'm Ozgur <span className={styles.dash}>-</span>{" "}
            <span>sr. software developer</span>
          </h1>
          <p className={styles.description}>
            I love coding. I have a decade of experience with web technologies.
          </p>
        </header>
        <a
          href="https://cv.ozgur.works/"
          target="_blank"
          rel="noreferrer"
          className={styles.cvButton}
        >
          View My CV
        </a>
        <div className={styles.links}>
          <a
            href="https://github.com/ozziest"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="My GitHub account"
          >
            <GitHubIcon />
          </a>
          <a
            href="https://log.ozgur.works"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="My blog"
          >
            <BlogLogo />
          </a>
          <a
            href="http://linkedin.com/in/ozguradem"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="My LinkedIn account"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://www.youtube.com/@OzgurAdemISIKLI"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Live coding, Axe API videos, etc."
          >
            <YoutubeIcon />
          </a>
          <a
            href="https://www.producthunt.com/@iozguradem"
            target="_blank"
            rel="noreferrer"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="What I do make?"
          >
            <ProductHuntIcon />
          </a>
        </div>
      </div>
      <Tooltip id="my-tooltip" place="bottom" />
    </div>
  );
}

export default App;
